import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import img3 from "../../assets/images/create.png";
import PlaylistReview from "../video-review/PlaylistReview";
const Newplaylist = ({ moderator, getPlaylist, showsearch }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const setCreateTable = (value) => {
    searchParams.set("createTable", value);
    navigate({ search: searchParams.toString() });
  };
  const setCreateModeratorPlaylist = (value) => {
    searchParams.set("CreateModeratorPlaylist", value);
    navigate({ search: searchParams.toString() });
  };
  const isPlaylistCreated =
    searchParams.get("CreateModeratorPlaylist") === "true";

  const handleClick = () => {
    if (moderator) {
      setCreateModeratorPlaylist(true);
      // navigate("/playlist");
    } else {
      setCreateTable(true);
    }
  };
  if (isPlaylistCreated) {
    return <PlaylistReview getPlaylist={getPlaylist} showsearch={showsearch} />;
  }
  return (
    <div className="h-100">
      <div className="text-center p-5 h-100">
        <h5 className="mt-2">Diving into the world of video playlists</h5>
        <h3 className="fw-bold m-3">
          Start your journey with a click, and let the <br />
          binge-watching adventure begin!
        </h3>
        <img src={img3} style={{ height: moderator ? "50%" : "" }} />
        <br />
        <button
          className="btn btn-dark mt-4"
          onClick={() => {
            // moderator ? setCreateModeratorPlaylist(true) : setCreateTable(true);
            handleClick();
          }}
        >
          {moderator ? "Create Playlist" : " Create new playlist"}
        </button>
      </div>
    </div>
  );
};

export default Newplaylist;
